import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import StatsSection from "@/components/StatsSection";
import ServicesSection from "@/components/ServicesSection";
import StandardsMarquee from "@/components/StandardsMarquee";
import MaturityQuiz from "@/components/MaturityQuiz";
import CaseStudies from "@/components/CaseStudies";
import WhyBaobSec from "@/components/WhyBaobSec";
import ApproachSection from "@/components/ApproachSection";
import FAQSection from "@/components/FAQSection";
import TestimonialSection from "@/components/TestimonialSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="relative grain overflow-hidden">
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <StatsSection />
        <ServicesSection />
        <StandardsMarquee />
        <MaturityQuiz />
        <CaseStudies />
        <WhyBaobSec />
        <ApproachSection />
        <FAQSection />
        <TestimonialSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
